<template>
	<Layout>
		<JumbotronCarousel
			v-if="slides.length > 0"
			:slides="slides"
			:has-header-sponsors="headerSponsors && headerSponsors.length > 0"
			:alternative-header-active="$arenaConfig.alternativeHeader"
		>
			<template #after>
				<HeaderSponsors
					v-if="headerSponsors"
					:sponsors="headerSponsors"
				/>
			</template>
		</JumbotronCarousel>
		<JumbotronKrone
			v-else-if="$arenaConfig.isKrone"
			:title="title"
		>
			<template #after>
				<HeaderSponsors
					v-if="headerSponsors && !$arenaConfig.alternativeHeader"
					:sponsors="headerSponsors"
				/>
			</template>
		</JumbotronKrone>
		<Jumbotron
			v-else
			:bg-image-url="bgImageUrl"
			:title="title"
		>
			<template #after>
				<HeaderSponsors
					v-if="headerSponsors && !$arenaConfig.alternativeHeader"
					:sponsors="headerSponsors"
				/>
			</template>
		</Jumbotron>
		<HeaderSponsors
			v-if="headerSponsors && $arenaConfig.alternativeHeader"
			:sponsors="headerSponsors"
			:alternative-header-active="true"
		/>
		<div class="l-container">
			<div
				v-for="lane in mixedLanes"
				:key="lane.id"
				class="l-content-section-w js-content-section"
				:class="[
					{
						'-highlighted': lane.highlighted
					},
					`-${lane.lane_type}`
				]"
			>
				<EventLane
					v-if="lane.visible && lane.storeId"
					:store-id="lane.storeId"
					:album-id="lane.albumId"
					:title="lane.title"
					:subtitle="lane.subtitle"
					:more-link="lane.moreLink"
					:lane-type="lane.lane_type"
					:highlighted="lane.highlighted"
					:ad="lane.ad"
					:labels="lane.labels"
				/>
				<AdLane
					v-if="lane.lane_type === ArenaLaneType.AD && lane.visible"
					:ad="lane.ad"
				/>
				<CollectionLane
					v-if="lane.lane_type === ArenaLaneType.COLLECTION && lane.visible"
					:collection="lane.arena_collection"
					:center-horizontally="lane.config?.centerHorizontally || false"
				/>
			</div>
			<EmptyState
				v-if="noEvents"
				:title="$I18n.trans_choice('commons.event', 2)"
				:text="$I18n.trans('arena.placeholder.replays')"
			/>
		</div>
	</Layout>
</template>

<script>
import Layout from '@js/Views/Layout';
import Jumbotron from '@js/components/Jumbotron';
import JumbotronCarousel from '@js/components/JumbotronCarousel';
import JumbotronKrone from '@js/components/JumbotronKrone';
import EventLane from '@js/components/EventLane';
import AdLane from '@js/components/AdLane';
import CollectionLane from '@js/components/CollectionLane';
import EmptyState from '@js/components/EmptyState';
import HeaderSponsors from '@js/components/HeaderSponsors';
import { AdType } from '@shared/enums/AdType';
import { ArenaLaneType } from '@shared/enums/ArenaLaneType';
import { laneMixer } from '@js/utils/laneMixer';

export default {
	name:       'ViewSubsite',
	components: { Layout, Jumbotron, JumbotronCarousel, JumbotronKrone, AdLane, CollectionLane, EventLane, EmptyState, HeaderSponsors },
	props:      {
		bgImageUrl: {
			type:    String,
			default: null,
		},
		title: {
			type:    String,
			default: null,
		},
		slides: {
			type:    Array,
			default: () => [],
		},
		lanes: {
			type:    Array,
			default: () => [],
		},
		ads: {
			type:    Array,
			default: () => [],
		},
		highlightedAd: {
			type:    Object,
			default: null,
		},
	},
	data() {
		return {
			ArenaLaneType,
		};
	},
	computed: {
		mixedLanes() {
			// get all albums from store
			const albumEntries = Object.entries(this.$store.state.events).filter(([key]) => key.startsWith('album_'));
			const albums = albumEntries.map(([key, value]) => {
				return {
					id:       parseInt(key.replace('album_', '')),
					events:   value.items,
					subtitle: value.subtitle,
					imgUrl:   value.imgUrl,
				};
			});
			return laneMixer(
				albums,
				this.lanes,
				this.$store,
				{
					highlighted: this.highlightedAd,
					normal:      this.ads,
				},
			);
		},
		noEvents() {
			return this.mixedLanes.filter(lane => !!lane.storeId).every(lane => {
				return this.$store.state.events[lane.storeId].items.length === 0;
			});
		},
		headerSponsors() {
			const headerSponsors = this.ads.find(ad => ad.type === AdType.SPONSORS_HEADER);
			return headerSponsors ? headerSponsors.logos : null;
		},
	},
};
</script>

<style>

</style>
